import { IError } from '../types/interface/login';

export const TitleLabels = {
    contractant: {
      nom: 'Nom',
      prenom: 'Prénom(s)',
      telephone: 'Téléphone',
      email: 'Email',
      ville: 'Ville',
      adresse: 'Adresse',
      password: 'Mot de passe ',
      image: '',
    },
};

export const defaultValues: IError =
{
    email: '',
    password: '',
};

export const showErrorValuesDefault =
{
    email: false,
    password: false,
};

export const showErrorValuesSubmit =
{
    email: true,
    password: true,
};
